import queryString from 'query-string';

export default function preparePlayUrl(baseUrl: string, timestamp: number) {
  const { url, query } = queryString.parseUrl(baseUrl);
  query.t = timestamp.toString();
  return queryString.stringifyUrl({ url, query });
}
